import { Tag } from "antd";
import { MoreMenu } from "datastake-daf/dist/components";
import moment from "moment";

export const getColumns = ({ t }) => [
  {
    title: t('Name'),
    dataIndex: 'name',
    key: 'name',
    ellipsis: true,
  },
  {
    title: t('Task'),
    dataIndex: 'task',
    key: 'task',
    ellipsis: true,
  },
  {
    title: t('Timeline'),
    dataIndex: 'timeline',
    key: 'timeline',
    ellipsis: true,
    render: (_, val) => {
      if (val.empty) {
        return <div className="daf-default-cell md" />;
      }

      return moment(val).format('DD MMM YYYY')
    },
  },
  {
    title: t('Status'),
    dataIndex: 'status',
    key: 'status',
    width: 100,
    render: (status, val) => {
      if (val.empty) {
        return <div className="daf-default-cell md" />;
      }

      let config = { label: 'Upcoming' };

      if (status === 'to-do') {
        config = { label: 'To do', color: 'orange' }
      }

      if (status === 'completed') {
        config = { label: 'Completed', color: 'green' }
      }

      return <Tag color={config.color}>{config.label}</Tag>;
    },
  },
  {
    title: '',
    width: 60,
    dataIndex: 'task',
    key: 'task',
    render: (_, val) => {
      if (val.empty) {
        return <div className="daf-default-cell md" />;
      }

      return <MoreMenu items={[]} />;
    }
  },
];
